import React from 'react';
import { Col, Row } from 'antd';
import { ENV_VERSION, ENV_NAME } from './../../config/Environment';
import './FooterContentForm.less';

class FooterContentForm extends React.Component {
  render() {
    return (
      <Row>
        <Col span={24}>
          <Row>
            <Col span={24} align={'center'}>
              <label className={'gainsboro-text'}>
                Copyright {new Date().getFullYear()} -&nbsp;
              </label>
              <label
                className={'footer-menu-link'}
                onClick={() => window.open('https://www.process-factory.dk/', 'process-factory')}
              >
                Process Factory
              </label>
              .<label className={'gainsboro-text'}> All rights reserved.</label>
            </Col>
          </Row>

          {ENV_VERSION ? (
            <Row>
              <Col span={24} align={'right'}>
                <div className={'gainsboro-text'}>
                  version: {ENV_VERSION} {ENV_NAME ? <span>- {ENV_NAME}</span> : null}
                </div>
              </Col>
            </Row>
          ) : null}
        </Col>
      </Row>
    );
  }
}

export default FooterContentForm;
